import React, { useMemo } from 'react';
import { jwtDecode } from 'jwt-decode';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import AppShell from './AppShell';
import { clearCacheAndReload } from '../pwa';


const Wrap = styled.div`
  padding: 16px;
  padding-left: calc(16px + var(--safe-left));
  padding-right: calc(16px + var(--safe-right));
`;

const Card = styled.div`
  background: var(--tg-surface);
  border: 1px solid var(--tg-border);
  border-radius: var(--tg-radius);
  box-shadow: var(--tg-shadow);
  padding: 16px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

const Label = styled.div`
  color: var(--tg-muted);
  font-size: 12px;
`;

const Value = styled.div`
  color: var(--tg-text);
  font-size: 14px;
  font-weight: 600;
`;

const Button = styled.button`
  width: 100%;
  margin-top: 12px;
  padding: 12px 14px;
  border-radius: var(--tg-radius-sm);
  border: 1px solid var(--tg-border);
  background: rgba(255,255,255,0.08);
  color: var(--tg-text);
  cursor: pointer;

  &.primary {
    border-color: rgba(42, 158, 241, 0.35);
    background: rgba(42, 158, 241, 0.18);
  }

  &.danger {
    border-color: rgba(255, 77, 77, 0.35);
    background: rgba(255, 77, 77, 0.18);
  }
`;

const Settings = () => {
  const navigate = useNavigate();

  const account = useMemo(() => {
    const token = localStorage.getItem('token');
    if (!token) return { username: 'Unknown' };
    try {
      const decoded = jwtDecode(token);
      return { username: decoded?.username || 'Unknown' };
    } catch {
      return { username: 'Unknown' };
    }
  }, []);

  const logout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  
  return (
    <AppShell title="تنظیمات">
      <Wrap>
        <Card>
          <Row>
            <div>
              <Label>حساب</Label>
              <Value>{account.username}</Value>
            </div>
          </Row>
                    <Button className="danger" onClick={logout}>خروج از حساب</Button>
          <Button 
            style={{ marginTop: '12px' }}
            onClick={() => {
              if (window.confirm('This will clear all local data and reload the app. Are you sure?')) {
                clearCacheAndReload();
              }
            }}
          >
            Hard Reset Application
          </Button>
        </Card>

              </Wrap>
    </AppShell>
  );
};

export default Settings;
